var _path, _path2, _path3, _line, _line2, _line3, _line4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 146 141",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.122 107.79-0.1659-12.001c14.321-0.7157 20.293 2.4771 28.366 11.835l-28.2 0.166zm-25.657 0.055c2.6541-7.322 12.22-10.79 19.961-11.67l0.1659 11.56-20.127 0.11zm62.759-0.11c-12.662-17.01-22.892-20.038-41.029-18.551-27.481 2.0367-32.513 14.917-32.181 37.707v0.165c0.05529 1.872 1.5482 3.413 3.4836 3.413l4.9765-0.055c0.33176-6.661 5.8059-12 12.607-12.055 6.8566-0.055 12.441 5.229 12.994 11.89l21.067-0.11c0.3317-6.661 5.8059-12 12.607-12.056 6.8566-0.055 12.441 5.23 12.994 11.891h3.8707c1.9353 0 3.4282-1.597 3.4282-3.413-0.0553-4.569 1.493-13.157-14.819-18.826zm-7.3542 25.817c-1.3823-1.156-1.6035-3.138-0.4976-4.514s3.1518-1.541 4.5341-0.44c1.3824 1.156 1.6036 3.137 0.4977 4.513-1.1059 1.377-3.1518 1.542-4.5342 0.441zm7.9624-9.689c-4.0365-3.302-9.953-2.752-13.215 1.267-3.2623 3.963-2.6541 9.853 1.3824 13.156s9.953 2.752 13.215-1.266c3.2624-3.964 2.5988-9.854-1.3824-13.157zm-54.52 9.854c-1.3823-1.156-1.6035-3.138-0.4976-4.514s3.1518-1.541 4.5341-0.44c1.3824 1.156 1.6036 3.137 0.4977 4.514-1.1059 1.431-3.1518 1.596-4.5342 0.44zm7.9624-9.633c-4.0365-3.303-9.953-2.753-13.215 1.266-3.2623 3.963-2.6541 9.853 1.3824 13.156s9.953 2.752 13.215-1.266c3.2624-4.019 2.5988-9.909-1.3824-13.156z",
    fill: "#0000C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36.032 69.919h-33.494v-30.553h46.239v-36.448h49.08v82.964m9 47.149 36.67-0.358v-85.326l-45.67-30.96",
    stroke: "url(#f)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 16,
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m54.39 64.137v2.8074h2.1012c0.3871 0 0.7188 0.3303 0.7188 0.7157 0 0.3853-0.3317 0.7156-0.7188 0.7156h-2.1012v2.8074h2.1012c0.3871 0 0.7188 0.3303 0.7188 0.7156s-0.3317 0.7156-0.7188 0.7156h-2.1012v2.8074h4.2577v-11.23h-4.2577v-0.0551zm0-2.8074h4.2577c1.5483 0 2.82 1.2661 2.82 2.8074v11.23c0 1.5413-1.2717 2.8074-2.82 2.8074h-4.2577c0 0.7707-0.6082 1.4313-1.4376 1.4313h-6.6354c-0.2764 0-0.5529-0.1101-0.7741-0.2202l-8.1283-3.9635h-2.82c-0.7741 0-1.4377-0.6055-1.4377-1.4312v-8.4222c0-0.7707 0.6083-1.4313 1.4377-1.4313h2.82l8.1283-3.9634c0.2212-0.1651 0.4977-0.2202 0.7741-0.2202h6.6354c0.7741 0 1.4376 0.6055 1.4376 1.3762z",
    fill: "url(#e)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64.015,
    x2: 83.015,
    y1: 20.871,
    y2: 20.871,
    stroke: "url(#d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64.015,
    x2: 83.015,
    y1: 44.816,
    y2: 44.816,
    stroke: "url(#c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 112.02,
    x2: 131.02,
    y1: 68.762,
    y2: 68.762,
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 112.02,
    x2: 119.02,
    y1: 44.816,
    y2: 44.816,
    stroke: "url(#a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 72.877,
    x2: 72.877,
    y1: 8.7926,
    y2: 128.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 47.282,
    x2: 47.282,
    y1: 60.84,
    y2: 78.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 85.015,
    x2: 61.515,
    y1: 23.871,
    y2: 23.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 85.015,
    x2: 61.515,
    y1: 47.816,
    y2: 47.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 133.02,
    x2: 109.52,
    y1: 71.762,
    y2: 71.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 121.02,
    x2: 109.78,
    y1: 47.816,
    y2: 47.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyCar);
export default __webpack_public_path__ + "static/media/companyCar.2680cac7e437b7424c8d7dcc3fe00bc9.svg";
export { ForwardRef as ReactComponent };